// src/v2/pages/Reports/ReportER2.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useReportER2 } from '../../hooks/useReportER2';
import { ReportER2Module } from '../../components/modules/Reports/ReportER2/ReportER2Module';

const ReportER2 = ({ isHideSideMenu }) => {
  const reportHook = useReportER2();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportER2Module reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default ReportER2;